<template>
    <div>
        <div class="container wrapper-404">

        </div>
    </div>
</template>
<script>
import { ensureGdprCookies } from '@/common/js/gdprCookie';
import nprogress from 'nprogress';
export default {
    computed: {

        userStatus () {

            return this.$store.state.user.status;

        }
    },
    watch: {

        async userStatus () {

            await ensureGdprCookies( this.$i18n.locale );
            nprogress.done();

        }

    }
};
</script>
<style style="less">
    .wrapper-404 {
        min-height: calc( 100vh - 0.88rem );
        background: #fff url(IMAGE/404/404.png) no-repeat center center;
        background-size: 100% auto;
    }
    @media screen and (max-width: 800px) {
        .wrapper-404 {
            background-size: 220% auto;
        }
    }
</style>
